import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { Title } from '@angular/platform-browser';



@Component({
  selector: 'app-network-metrics',
  templateUrl: './network-metrics.component.html',
  styleUrls: ['./network-metrics.component.css']
,
  standalone: false
})
export class NetworkMetricsComponent implements OnInit {

  selectedTab: number;
  ramData: any;
  ramObj: { serverName: any; percentage: any; };
  cpuData: any;
  loadingUserMessage: string = 'Loading ...';
  loadingRAMMessage: string = 'Loading ...';
  loadingCPUMessage: string = 'Loading ...';


  selectTab(tab: number) {
    this.selectedTab = tab;
    this.ramUsage()
  }
  
  data = [];
  percentageValue: any[];
  dataAvailable: boolean = false;

  constructor(public restService: RestService,
    private titleService: Title,) {
      this.titleService.setTitle("Cloud Infrastructure");
    
   }

  ngOnInit(): void {
    this.ramUsage()
    this.cpuUsage()
    let title = this.titleService.getTitle();
  }

  cpuUsage(){
    this.loadingCPUMessage = 'Loading ...';
    let url = AppSettings.CPU_USAGE;
    this.restService.getcpuUsage(url).subscribe((data:any)=>{
      if(data && data?.length>0){
        this.loadingCPUMessage ="";        
      this.cpuData = data;
      }else if(data && data?.length ==0){
        this.loadingCPUMessage = 'No Data Found';        
        this.cpuData = data;
      }
    },(error:any)=>{
      this.cpuData =[];
      this.loadingCPUMessage ="We are unable to load the data. Please try after sometime."; 
    })
  }


  ramUsage(){
    this.loadingRAMMessage = 'Loading ...';
    let url = AppSettings.RAM_USAGE;
    this.restService.getRamUsage(url).subscribe((data:any) => {
      if(data && data?.length>0){
        this.loadingRAMMessage ="";        
      this.ramData = data;
      } else if(data && data?.length ==0){
        this.loadingCPUMessage = 'No Data Found';        
        this.cpuData = data;
      }
    },(error:any)=>{
      this.ramData=[];
      this.loadingRAMMessage ="We are unable to load the data. Please try after sometime."; 
    });
  }

  getProgressColor(percentageValue: any) {
    if (percentageValue >= 85) {
      return 'warn';
    } else if (percentageValue <85 && percentageValue >= 40) {
      return 'primary';
    } else if (percentageValue < 40) {
      return 'accent'
    } else {
      return '';
    }
  }
  
  

}
